
import React from 'react';
import { Link } from 'office-ui-fabric-react/lib/Link';
import { Text } from 'office-ui-fabric-react/lib/Text';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { FontWeights } from 'office-ui-fabric-react';
import { mergeStyleSets } from '@uifabric/merge-styles';

const ContentNavigationItemSeparator = () => {
    const classNames = mergeStyleSets({
        root: {
            fontSize: '14px',
            fontWeight: 'bold',
            paddingTop: '4px',
            paddingLeft: '4px',
            paddingRight: '4px',
            color: '#777777'
        }
    });

    return (
        <div className={classNames.root}>
            <Icon iconName="ChevronRightSmall"/>
        </div>
    );
}

const ContentNavigationItemLink = ({title, path}) => {
    return (
        <Text variant="large"><Link href={path}>{title}</Link></Text>
    );
}

const ContentNavigationItemText = ({title}) => {

    const classNames = mergeStyleSets({
        root: {
            fontWeight: FontWeights.semibold
        }
    });

    return <Text variant="large" className={classNames.root}>{title}</Text>
}

const ContentNavigationItem = ({item, first, last, paths}) => {
    const classNames = mergeStyleSets({
        root: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center'
        }
    });

    let path = paths[item.id]
        ? paths[item.id]
        : item.path;

    return (
        <div className={classNames.root}>
            {(!first) ? <ContentNavigationItemSeparator /> : null}
            {(last)
                ? <ContentNavigationItemText title={item.title} />
                : <ContentNavigationItemLink title={item.title} path={path} />
            }
        </div>
    );
}

const ContentNavigation = (props) => {
    const classNames = mergeStyleSets({
        root: {
            display: 'flex',
            flexDirection: 'row',
            fontSize: '12px'
        }
    });

    return (
        <div className={classNames.root}>
            {props.items.map((item, index) => {
                return (
                    <ContentNavigationItem
                        key={index}
                        item={item}
                        first={index === 0}
                        last={index === (props.items.length - 1)}
                        paths={props.paths}
                    />
                );
            })}
        </div>
    );
}

export default ContentNavigation;
